import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=7a8c295d&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a8c295d')) {
      api.createRecord('7a8c295d', component.options)
    } else {
      api.reload('7a8c295d', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=7a8c295d&", function () {
      api.rerender('7a8c295d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2L9MoID4sXSvZ/JS/offershelp.vue"
export default component.exports